/**
 * The most terrible camelizer on the internet, guaranteed!
 *
 * @param {string} str String that isn't camel-case, e.g., CAMeL_CaSEiS-harD
 *
 * @return {string} String converted to camel-case, e.g., camelCaseIsHard
 */
export const convertToCamelCase = str => `${str.charAt(0).toLowerCase()}${str.replace(/[\W_]/g, '|').split('|')
	.map(part => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
	.join('')
	.slice(1)}`;

/**
 * Check if a string has capitalized letters in it.
 *
 * @param str String The string being checked for caps
 *
 * @returns {boolean}
 */
export const isCamelCase = str => /[A-Z]/.test(str);
